import {
  DropdownWrapper,
  DropdownPanel,
  DropdownTrigger,
  ButtonWrapper,
  Link,
  Avatar,
  useUser,
  classNames
} from '@/core'
import {Logo} from '@c/logo'
import {UserList} from '@c/user-list'
import {doc} from './doc'
import styles from './style.module.styl'

const UserAvatar = ({user, ...props}) =>
  <Avatar
    letter={user.info.profile.isNonprofitAccount ? user.info.nonprofit.name[0] : user.info.profile.firstName?.[0] || user.info.profile.email[0]}
    src={user.info.profile.isNonprofitAccount ? user.info.nonprofit.logo?.link : user.info.profile.firstName?.[0]}
    square={user.info.profile.isNonprofitAccount}
    {...props}
  />

export const Header = doc(
  ({narrow}) => {
    const user = useUser()
    return (
      <header className={styles.header} >
        <div className={classNames(narrow && styles.narrow)} >
          <Link name={user?.info?.homeUrlName || 'todo'}><Logo /></Link>
          {!user && <div>Sign up</div>}
          {user && 
            <div className={styles.right}>
              {/* <DropdownWrapper> */}
              {/*   <DropdownTrigger name='menu'> */}
              {/*     {({className, ...props}) => */}
              {/*       <ButtonWrapper className={u.classNames(className, styles.menuButton)} {...props} > */}
              {/*         <Menu /> */}
              {/*       </ButtonWrapper> */}
              {/*     } */}
              {/*   </DropdownTrigger> */}
              {/*   <DropdownPanel name='menu' > */}
              {/*     <div className={styles.links} > */}
              {/*       {user.info.profile.email.includes('purposely.co') && <Link name='componentDocs'>Docs</Link>} */}
              {/*       {user.info.profile.isPurposelyAdmin && <Link name='adminMetrics'>Admin</Link>} */}
              {/*     </div> */}
              {/*   </DropdownPanel> */}
              {/* </DropdownWrapper> */}
              <DropdownWrapper>
                <DropdownTrigger name='user'>
                  {(props) =>
                    <ButtonWrapper {...props} >
                      <UserAvatar user={user} size='medium' mobileSize='small' />
                    </ButtonWrapper>
                  }
                </DropdownTrigger>
                <DropdownPanel name='user' >
                  <Link name={user.info.homeUrlName} className={styles.currentUser} >
                    <UserAvatar size='medium' user={user} />
                    <div>
                      {
                        user.info.profile.isNonprofitAccount
                          ? user.info.nonprofit.name
                          : user.info.profile.firstName ? `${user.info.profile.firstName} ${user.info.profile.lastName}`
                          : 'No name'
                      }
                    </div>
                    <div>{user.info.profile.email}</div>
                  </Link>
                  <UserList filterOutCurrentUser />
                </DropdownPanel>
              </DropdownWrapper>
            </div>
          }
        </div>
      </header>
    )
  }
)
